import React,{Component} from 'react';
import {jumpToLogin} from '../util'

export default class LoginBar extends Component{
    constructor(props){
        super(props)
        this.state = {
            show: true
        }
    }
    render(){
        const {isLogin} = this.props; 
        const {show} = this.state;
        const clickHandler = ()=>{
            this.setState({show:false})
        }
        return (!isLogin&&show) &&
            <div className="np-buylogin">
                <div className="np-main">
                    <p>为了方便购买，请提前登录<a href="javascript:;" onClick={jumpToLogin}>立即登录</a><i className="i-close" title="关闭" onClick={clickHandler}></i></p>
                </div>
            </div>
    }
    
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/components/loginbar.jsx